import React from "react";
import "./LandingServices.css";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const LandingServices = () => {
  React.useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const landingServicesList = [
    {
      title: "Laparoscopic Surgery",
      desc: (
        <>
          Minimally invasive procedures ensuring faster recovery, smaller scars, and reduced pain.<br />
          Advanced keyhole surgeries performed with precision and modern technology.
        </>
      ),
      img: "/images/services/laproscopy.webp",
      alt: "Laparoscopic Surgery in Indapur – Minimally invasive keyhole procedures"
    },
    {
      title: "Gastrointestinal Endoscopy",
      desc: (
        <>
          High-precision endoscopic examinations for accurate diagnosis and treatment of GI conditions.<br />
          Safe, advanced, and painless procedures for stomach, intestine, and digestive issues.
        </>
      ),
      img: "/images/services/endoscopy.webp",
      alt: "Gastrointestinal Endoscopy in Indapur – Advanced stomach and intestine endoscopy"
    },
    {
      title: "Hernia / Hydrocele / Appendix",
      desc: (
        <>
          Expert surgical care for hernia, hydrocele, and appendix with quick recovery.<br />
          Safe, reliable procedures performed using advanced surgical techniques.
        </>
      ),
      img: "/images/services/hernia.webp",
      alt: "Hernia, Hydrocele, Appendix treatment in Indapur – Expert surgical care"
    },
    {
      title: "Pregnancy Care",
      desc: (
        <>
          Complete antenatal care with regular monitoring for a healthy and safe pregnancy.<br />
          Personalized pregnancy support from early stages to delivery.
        </>
      ),
      img: "/images/services/pregnancy.webp",
      alt: "Pregnancy Care in Indapur – Expert antenatal care and monitoring"
    },
    {
      title: "IVF (Test Tube Baby)",
      desc: (
        <>
          Advanced fertility treatments designed to support couples on their parenthood journey.<br />
          High-success IVF with modern technology and compassionate care.
        </>
      ),
      img: "/images/services/ivf.webp",
      alt: "IVF Treatment in Indapur – Test Tube Baby & Fertility Care"
    },
    {
      title: "Normal & Cesarean Delivery",
      desc: (
        <>
          Safe and trusted delivery care by experienced obstetric specialists.<br />
          Comfortable birthing experience with advanced facilities and expert monitoring.
        </>
      ),
      img: "/images/services/delivery.webp",
      alt: "Normal and Cesarean Delivery in Indapur – Safe maternity care"
    },
  ];

  return (
    <section className="ls-wrapper" role="region" aria-label="Hospital Key Medical Services">

      {/* Invisible to users – Google SEO boost */}
      <div style={{ display: "none" }}>
        Best Multispeciality Hospital in Indapur, Laparoscopy Indapur, Endoscopy Indapur,
        Pregnancy care Indapur, IVF Test Tube Baby Center Indapur, Cesarean Delivery Indapur,
        Hernia Surgery Indapur, Hydrocele Treatment Indapur, Appendix Surgery Indapur.
      </div>

      <h2 className="ls-title" data-aos="fade-up">
        Our Key Medical Services
      </h2>

      <div className="ls-grid">
        {landingServicesList.map((item, index) => (
          <article
            className="ls-card"
            data-aos="fade-up"
            data-aos-delay={index * 150}
            key={index}
            role="article"
          >
            <figure className="ls-img-box">
              <img src={item.img} alt={item.alt} loading="lazy" />
            </figure>

            <h3 className="ls-card-title">{item.title}</h3>
            <p className="ls-card-desc">{item.desc}</p>
          </article>
        ))}
      </div>

      <div className="ls-btn-container" data-aos="fade-up">
        <Link to="/services" className="ls-btn-main">
          View All Services
        </Link>
      </div>

      {/* ============================
          ⭐ JSON-LD SCHEMA (SEO GOLD)
          ============================ */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalBusiness",
          "name": "Dr. Chavan Multispeciality Hospital Indapur",
          "description": "Best multispeciality hospital in Indapur providing laparoscopic surgery, endoscopy, pregnancy care, IVF, normal delivery, cesarean delivery and general surgery.",
          "url": "https://drchavanhospital.in",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Indapur",
            "addressRegion": "Maharashtra",
            "addressCountry": "India"
          },
          "medicalSpecialty": landingServicesList.map(s => s.title),
        })}
      </script>

    </section>
  );
};

export default LandingServices;
